module.exports = __webpack_public_path__ + "static/campus@large-58f977d6db54b628556adfeab4682944.jpg";